"use client";

import { useEffect, useState } from "react";

import {
  type AppRelease,
  isApkConfigured,
  isPlayStoreConfigured,
  loadAppRelease,
  playStoreUrl,
} from "@/lib/appDownload";

export type AppAvailability =
  | { route: "loading" }
  | { route: "play"; url: string }
  | { route: "apk"; release: AppRelease }
  | { route: "none" };

// Play Store wins when it is configured: it is the canonical way to install a
// released app, and it needs no runtime check, so production resolves without a
// fetch. Only the APK route waits on the manifest.
export function useAppAvailability(): AppAvailability {
  const [state, setState] = useState<AppAvailability>(() => {
    if (isPlayStoreConfigured) {
      return { route: "play", url: playStoreUrl };
    }
    return isApkConfigured ? { route: "loading" } : { route: "none" };
  });

  useEffect(() => {
    if (isPlayStoreConfigured || !isApkConfigured) {
      return;
    }
    let cancelled = false;
    loadAppRelease().then((release) => {
      if (!cancelled) {
        setState(release ? { route: "apk", release } : { route: "none" });
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
